import { FC, useContext } from 'react';
import { Menu, Spinner } from '@chakra-ui/react';

import { useApplicationRunPpsrIntegration } from '~/core/shared/api/middle-office/application/hooks/useApplicationRunPpsrIntegration';
import {
  ApplicationContext,
  DocumentDetailsViewActionContext,
} from '../Layout.component';

export const PpsrMenuItem: FC = () => {
  const { applicationUuid, definition } = useContext(ApplicationContext);

  const {
    action: { text },
  } = useContext(DocumentDetailsViewActionContext);

  const { runPpsrIntegration, isPending } =
    useApplicationRunPpsrIntegration(definition);

  const handleRunPpsrIntegration = async (): Promise<void> => {
    try {
      await runPpsrIntegration({
        uuid: applicationUuid,
        data: { uuid: applicationUuid },
      });
    } catch (error: unknown) {
      console.error(error);
      // Error is handled in useApplicationRunPpsrIntegration
    }
  };

  return (
    <Menu.Item onClick={handleRunPpsrIntegration} value="ppsr">
      {isPending && <Spinner size="xs" />}
      {text}
    </Menu.Item>
  );
};
